import { Box, Grid } from "@mui/material";
import { setInnCode, setLibraryRecentSearch } from "components/app/App.slice";
import Feedback from "components/common/Feedback";
import { filterPage } from "components/common/Filters/FiltersHelper";
import GlobalFilterDescription from "components/common/Filters/GlobalFilterDescription";
import GlobalFilters from "components/common/Filters/GlobalFilters";
import NoPlansBanner from "components/common/NoPlansBanner";
import Scroller from "components/common/Scroller/InfiniteScroller";
import ActionCard from "components/features/ActionCard";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { PAGE_SIZE, messages } from "utils/CommonConstants";
import { formFilterRequestPayload, getHltInncodes } from "utils/CommonFunctions";
import { pageNames, planTypes } from "utils/Types";
import { fetchIndividualActionAsync, fetchIndividualActionDetailAsync } from "./individualAction.slice";

function IndividualAction() {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const searchText = searchParams.get("q") as string;
  const cardId = searchParams.get("cardid") as string;
  const [pageNo, setPageNo] = useState(1);
  const innCode = useAppSelector((state: any) => state.app.innCode);
  const localSearch = searchParams.get("search");
  const innCodes = getHltInncodes();
  const [multipleInncodeAction, setmultipleInncodeAction] = useState(false);
  const [multipleInncodeFeedback, setmultipleInncodeFeedback] = useState<any>();
  const individualActionList = useAppSelector((state: any) => state.individualAction.list);
  const individualActionLoader = useAppSelector((state: any) => state.individualAction.actionShowLoader);
  const individualActionDetail = useAppSelector((state: any) => state.individualAction.actionDetails);
  const totalRecords = useAppSelector((state: any) => state.individualAction.totalRecords);
  const [multiSelectMode, setMultiSelectMode] = useState(false);
  const selectedMyPlanDetail: any = useAppSelector((state) => state.myPlanDetails.myPlanDetails);

  const globalFiltersforPage = useAppSelector(
    (state) =>
      state.globalFilters[
        id
          ? filterPage.libraryFunctionalAreasIndividualActionsDisplay
          : filterPage.libraryAllPlansSearchIndividualActionsDisplay
      ]
  );

  const filterRequestPayload = globalFiltersforPage?.modifiedFilter || globalFiltersforPage?.defaultFilter || [];
  const formattedFilterRequestPayload = formFilterRequestPayload(filterRequestPayload);
  const libraryRecentSearch = useAppSelector((state) => state.app.libraryRecentSearch);

  useEffect(() => {
    const props: any = {
      filter: {
        functionalAreaIds: id ? [id] : [],
        innCode,
        ...formattedFilterRequestPayload
      },
      pagination: {
        page: 1,
        size: PAGE_SIZE
      },
      searchText: searchText || localSearch
    };
    dispatch(fetchIndividualActionAsync(props));
    setPageNo(1);
  }, [dispatch, id, innCode, searchText, localSearch, filterRequestPayload]);

  useEffect(() => {
    if (cardId) {
      const otherInnCode = individualActionDetail?.meta?.cardAvailableInncodes?.split(",");
      const hasOtherInncode = otherInnCode?.length > 0;
      if (individualActionDetail?.id) {
        setmultipleInncodeFeedback({
          innCode: multipleInncodeFeedback?.innCode,
          otherInnCodes: individualActionDetail?.meta?.cardAvailableInncodes?.split(",")
        });
        dispatch(setInnCode(multipleInncodeFeedback?.innCode));
        if (hasOtherInncode) setmultipleInncodeAction(true);
        navigate(location.pathname + "?q=" + encodeURIComponent(searchText), {
          state: { backURL: "/library", cardId: cardId }
        });
        return;
      }

      noAccessRedirect();

      innCodes?.splice(innCodes?.indexOf(hasOtherInncode ? otherInnCode[0] : innCode), 1);
      const props: any = {
        id: cardId,
        innCode: hasOtherInncode ? otherInnCode[0] : innCode,
        otherInnCodes: innCodes
      };
      setmultipleInncodeFeedback({
        innCode: hasOtherInncode ? otherInnCode[0] : innCode
      });
      dispatch(fetchIndividualActionDetailAsync(props));
    }
  }, [dispatch, cardId, individualActionDetail]);

  const noAccessRedirect = () => {
    const noAccessCondition =
      (Object.keys(individualActionDetail).length !== 0 && !individualActionDetail?.meta?.cardAvailableInncodes) ||
      individualActionDetail?.meta?.cardAvailableInncodes === null;
    if (noAccessCondition)
      navigate(`/`, { state: { hasNoAccess: true, message: "You don't have access to view this action!" } });
  };

  const fetchMore = () => {
    const props = {
      filter: {
        functionalAreaIds: id ? [id] : [],
        innCode,
        ...formattedFilterRequestPayload
      },
      pagination: {
        page: pageNo + 1,
        size: PAGE_SIZE
      },
      searchText: searchText || localSearch
    };
    dispatch(fetchIndividualActionAsync(props));
    setPageNo(pageNo + 1);
  };

  return (
    <Box marginTop="-16px">
      <Feedback
        form="copyAction"
        message={messages.actionAdded}
        linkLabel="Go to my plans"
        href={`/myplandetails/${selectedMyPlanDetail?.id}`}
      />
      <Feedback
        form=""
        actionStatus={{ shouldShow: multipleInncodeAction, variant: "warning" }}
        message={"You are viewing Action details for " + multipleInncodeFeedback?.innCode + "."}
      />
      <Feedback
        form="addToMyPlans"
        message={messages.planAdded}
        linkLabel="Go to my plans"
        href={`/myplandetails/${selectedMyPlanDetail?.id}`}
      />

      <Box marginBottom={"16px"}>
        <div
          style={{
            display: !id ? "flex" : undefined,
            justifyContent: !id ? "space-between" : undefined
          }}
        >
          {!id && <Box></Box>}
          <GlobalFilters
            isSearchBarVisible={id ? true : false}
            page={
              id
                ? filterPage.libraryFunctionalAreasIndividualActionsDisplay
                : filterPage.libraryAllPlansSearchIndividualActionsDisplay
            }
            functionalAreaId={id}
            applyFilterToMultiplePages={[filterPage.libraryAllPlansSearchDisplay]}
            libraryRecentSearch={libraryRecentSearch}
            setRecentSearch={setLibraryRecentSearch}
          />
        </div>
        <GlobalFilterDescription
          page={
            id
              ? filterPage.libraryFunctionalAreasIndividualActionsDisplay
              : filterPage.libraryAllPlansSearchIndividualActionsDisplay
          }
          bgColor={tokens.Background.General.Primary}
        />
      </Box>

      {individualActionList.length > 0 ? (
        <Scroller
          dataLength={individualActionList.length}
          loadMore={fetchMore}
          totalList={totalRecords}
          label="Actions"
        >
          <Grid
            container
            display="flex"
            flexDirection="row"
            justifyContent={"flex-start"}
            flexWrap="wrap"
            width={"100%"}
            gap={"40px"}
          >
            {individualActionList?.map((element: any) => {
              return (
                <ActionCard
                  multiCardSelect={multiSelectMode}
                  key={element.id}
                  item={element}
                  planType={planTypes.AllPlans}
                />
              );
            })}
          </Grid>
        </Scroller>
      ) : (
        <>
          {!individualActionLoader && (
            <Box marginBottom={"16px"}>
              <NoPlansBanner
                type={id ? pageNames.searchResultAction : pageNames.globalSearchResult}
                pageName={id ? pageNames.searchResultAction : pageNames.globalSearchResult}
              />
            </Box>
          )}
        </>
      )}
    </Box>
  );
}

export default IndividualAction;
